var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPorqueLumien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-62"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.19,
    cy: 387.81,
    rx: 15.74,
    ry: 23.17,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-62"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.72,
    cy: 387.81,
    rx: 10.02,
    ry: 23.17,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.61,344.12H337s7.43-2.48,5.31-11.68c-.72-3.12-15.57-10.26-17.69-10.26H299.12Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.91,411c4.62-17.67,19-82.07,6.7-159.8C708.16,159.63,615.81,80.93,528.27,52.83S319.48,133.13,258.45,154,65.72,182.12,39.22,272.86c-22.63,77.49,8,125.7,17.47,138.12Z",
    style: {
      fill: "#4EA32A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.91,411c4.62-17.67,19-82.07,6.7-159.8C708.16,159.63,615.81,80.93,528.27,52.83S319.48,133.13,258.45,154,65.72,182.12,39.22,272.86c-22.63,77.49,8,125.7,17.47,138.12Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mountains--inject-62"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "57.24 379.97 246.57 221.8 327.18 292.19 486.19 220.22 669.61 362.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "204.67 256.71 220.75 251.28 228.79 259.88 244.03 248.56 250.38 253.09 259.26 243.58 282.11 265.76 285.92 257.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "419.65 250.82 445.46 246.3 449.27 258.06 462.39 250.37 470.85 260.78 497.94 244.94 511.48 253.09 518.25 246.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615,411h92.62c-1.78-11.33-9.06-9.33-10-26.89-.49-8.84,7.69-19.78,7-31.39-.59-9.57-10-19.38-10.75-30.32-.66-9.88,7.39-20.83,6.61-31.48-.74-10.06-10.3-19.72-11.15-30.17-.83-10.21,7.06-21.28,6.13-31.59s-10.66-19.79-11.69-30c-1.06-10.46,6.56-21.71,5.4-31.72-1.24-10.62-11.26-19.79-12.62-29.57C675,127,682.12,115.36,680.46,106c-2-11.52-12.76-19.86-15-28.36-4.21-15.84-3.68-31.1-8.65-32.1-5.3-1.06-6.51,13.91-10.52,30.64-2,8.4-12.51,16.91-14.24,28.44-1.39,9.34,6,20.69,4.81,31.54-1.09,9.72-10.86,19.06-11.81,29.62-.89,9.93,7,20.89,6.26,31.27-.76,10.1-10.24,19.73-10.89,30s7.52,21,7,31.12c-.57,10.38-9.88,20.18-10.36,30.16-.5,10.56,7.83,21.21,7.43,31-.45,10.86-9.63,20.8-10,30.29-.41,11.52,8,22.15,7.79,30.92-.56,19-9.28,15.09-9.59,30.41Z",
    style: {
      fill: "#4EA32A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615,411h92.62c-1.78-11.33-9.06-9.33-10-26.89-.49-8.84,7.69-19.78,7-31.39-.59-9.57-10-19.38-10.75-30.32-.66-9.88,7.39-20.83,6.61-31.48-.74-10.06-10.3-19.72-11.15-30.17-.83-10.21,7.06-21.28,6.13-31.59s-10.66-19.79-11.69-30c-1.06-10.46,6.56-21.71,5.4-31.72-1.24-10.62-11.26-19.79-12.62-29.57C675,127,682.12,115.36,680.46,106c-2-11.52-12.76-19.86-15-28.36-4.21-15.84-3.68-31.1-8.65-32.1-5.3-1.06-6.51,13.91-10.52,30.64-2,8.4-12.51,16.91-14.24,28.44-1.39,9.34,6,20.69,4.81,31.54-1.09,9.72-10.86,19.06-11.81,29.62-.89,9.93,7,20.89,6.26,31.27-.76,10.1-10.24,19.73-10.89,30s7.52,21,7,31.12c-.57,10.38-9.88,20.18-10.36,30.16-.5,10.56,7.83,21.21,7.43,31-.45,10.86-9.63,20.8-10,30.29-.41,11.52,8,22.15,7.79,30.92-.56,19-9.28,15.09-9.59,30.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 654.78,
    y1: 75.93,
    x2: 654.78,
    y2: 406.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "669.24 110.61 654.16 123.63 641.82 107.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "669.24 168.18 654.16 181.21 641.82 164.76",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "669.24 222.33 654.16 235.35 641.82 218.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "669.24 286.76 654.16 299.78 641.82 283.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "669.24 351.87 654.16 364.89 641.82 348.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.7,411h69.19c-1.33-8.46-6.76-7-7.48-20.09-.37-6.6,5.74-14.77,5.22-23.45-.44-7.15-7.49-14.48-8-22.65-.5-7.38,5.52-15.57,4.93-23.52-.55-7.52-7.69-14.73-8.32-22.54-.62-7.62,5.27-15.9,4.58-23.6s-8-14.79-8.74-22.38c-.79-7.81,4.91-16.22,4-23.7-.92-7.93-8.41-14.78-9.42-22.09-1.13-8.14,4.17-16.83,2.93-23.86-1.52-8.61-9.53-14.84-11.22-21.19-3.14-11.83-2.75-23.24-6.46-24-4-.79-4.86,10.39-7.86,22.89-1.51,6.27-9.35,12.63-10.63,21.25-1,7,4.49,15.45,3.58,23.56-.81,7.26-8.1,14.24-8.81,22.13-.67,7.42,5.25,15.6,4.67,23.36-.57,7.54-7.65,14.74-8.14,22.4s5.62,15.68,5.2,23.25c-.43,7.75-7.38,15.07-7.73,22.53-.38,7.89,5.85,15.85,5.54,23.17-.33,8.11-7.19,15.54-7.44,22.63-.31,8.6,6,16.55,5.82,23.1-.43,14.22-6.94,11.27-7.17,22.72Z",
    style: {
      fill: "#4EA32A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.7,411h69.19c-1.33-8.46-6.76-7-7.48-20.09-.37-6.6,5.74-14.77,5.22-23.45-.44-7.15-7.49-14.48-8-22.65-.5-7.38,5.52-15.57,4.93-23.52-.55-7.52-7.69-14.73-8.32-22.54-.62-7.62,5.27-15.9,4.58-23.6s-8-14.79-8.74-22.38c-.79-7.81,4.91-16.22,4-23.7-.92-7.93-8.41-14.78-9.42-22.09-1.13-8.14,4.17-16.83,2.93-23.86-1.52-8.61-9.53-14.84-11.22-21.19-3.14-11.83-2.75-23.24-6.46-24-4-.79-4.86,10.39-7.86,22.89-1.51,6.27-9.35,12.63-10.63,21.25-1,7,4.49,15.45,3.58,23.56-.81,7.26-8.1,14.24-8.81,22.13-.67,7.42,5.25,15.6,4.67,23.36-.57,7.54-7.65,14.74-8.14,22.4s5.62,15.68,5.2,23.25c-.43,7.75-7.38,15.07-7.73,22.53-.38,7.89,5.85,15.85,5.54,23.17-.33,8.11-7.19,15.54-7.44,22.63-.31,8.6,6,16.55,5.82,23.1-.43,14.22-6.94,11.27-7.17,22.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 557.4,
    y1: 160.67,
    x2: 557.4,
    y2: 407.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "568.21 186.58 556.94 196.31 547.72 184.02",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "568.21 229.59 556.94 239.32 547.72 227.03",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "568.21 270.04 556.94 279.77 547.72 267.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "568.21 318.18 556.94 327.91 547.72 315.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "568.21 366.82 556.94 376.55 547.72 364.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.26,411h50.33c-1-6.15-4.92-5.07-5.45-14.61-.26-4.8,4.18-10.74,3.8-17.06-.32-5.19-5.44-10.52-5.84-16.47-.36-5.36,4-11.32,3.59-17.1-.4-5.47-5.6-10.71-6.06-16.4-.44-5.54,3.84-11.56,3.33-17.16s-5.79-10.75-6.35-16.28,3.57-11.79,2.94-17.23c-.68-5.77-6.12-10.75-6.86-16.07-.82-5.92,3-12.24,2.13-17.35-1.1-6.26-6.93-10.79-8.16-15.41-2.28-8.61-2-16.9-4.69-17.44-2.88-.58-3.54,7.55-5.72,16.64-1.1,4.57-6.8,9.19-7.74,15.46-.75,5.07,3.27,11.24,2.61,17.14-.59,5.27-5.89,10.35-6.41,16.09-.49,5.39,3.82,11.35,3.4,17-.41,5.48-5.56,10.72-5.92,16.29s4.09,11.41,3.78,16.91-5.36,11-5.62,16.39c-.28,5.73,4.25,11.52,4,16.84-.24,5.9-5.23,11.31-5.41,16.46-.23,6.26,4.37,12,4.23,16.8-.31,10.34-5,8.2-5.21,16.52Z",
    style: {
      fill: "#4EA32A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.26,411h50.33c-1-6.15-4.92-5.07-5.45-14.61-.26-4.8,4.18-10.74,3.8-17.06-.32-5.19-5.44-10.52-5.84-16.47-.36-5.36,4-11.32,3.59-17.1-.4-5.47-5.6-10.71-6.06-16.4-.44-5.54,3.84-11.56,3.33-17.16s-5.79-10.75-6.35-16.28,3.57-11.79,2.94-17.23c-.68-5.77-6.12-10.75-6.86-16.07-.82-5.92,3-12.24,2.13-17.35-1.1-6.26-6.93-10.79-8.16-15.41-2.28-8.61-2-16.9-4.69-17.44-2.88-.58-3.54,7.55-5.72,16.64-1.1,4.57-6.8,9.19-7.74,15.46-.75,5.07,3.27,11.24,2.61,17.14-.59,5.27-5.89,10.35-6.41,16.09-.49,5.39,3.82,11.35,3.4,17-.41,5.48-5.56,10.72-5.92,16.29s4.09,11.41,3.78,16.91-5.36,11-5.62,16.39c-.28,5.73,4.25,11.52,4,16.84-.24,5.9-5.23,11.31-5.41,16.46-.23,6.26,4.37,12,4.23,16.8-.31,10.34-5,8.2-5.21,16.52Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.87,
    y1: 228.94,
    x2: 91.87,
    y2: 408.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "99.72 247.78 91.53 254.85 84.83 245.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "99.72 279.06 91.53 286.14 84.83 277.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "99.72 308.48 91.53 315.56 84.83 306.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "99.72 343.49 91.53 350.56 84.83 341.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "99.72 378.87 91.53 385.94 84.83 377",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79,118.65c-1-1-2.71-2-5.69-2.05-6.69-.16-4.9,4.58-6.69,5.72s-2.29-.65-4.09.49-1,3.43-2.45,3.76-3.43-1.47-5.23-.33-1.79,2.12-2.61,2.12-2.45-.65-3.43,0-2.13,1.47-2.13,1.47H64.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.86,121.57l-.51-.23a4.46,4.46,0,0,0-.6-1.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.48,129.83H88a2.11,2.11,0,0,0-1.31-2.45c-1.8-1-2.61-.16-3.27-1s1.3-2.49-1.74-4.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.37,129.83h42.72s1.46-4.36-3.88-7.27-7.76-.49-9.7-2.92,5.33-8.73-9.22-15c0,0-1-13.58-20.87-14.07-8.58-.21-12.47,2.29-14.54,5.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.33,
    y1: 129.83,
    x2: 173.45,
    y2: 129.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.89,129.83H99.33s3.4-2.42,6.31-4.36,7.76,0,10.19,0,2.42-2.91,7.76-6.31,11.16,1.94,15.53,1,1.94-7.76,7.28-11.16,6.79,1.94,12.13-1.46c1.49-1,2.15-2.73,2.76-4.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.77,129.83h26.45s.91-2.7-2.4-4.5-4.81-.3-6-1.81,3.31-5.4-5.71-9.31c0,0-.6-8.41-12.92-8.71-5.31-.13-7.72,1.42-9,3.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 565.7,
    y1: 129.83,
    x2: 570.1,
    y2: 129.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.57,113a4.86,4.86,0,0,1-1.7,3c-3.31,2.11-4.21-1.2-7.52.9s-1.8,6.31-4.5,6.92-6.31-2.71-9.62-.61-3.3,3.91-4.8,3.91-4.51-1.2-6.31,0-3.91,2.7-3.91,2.7H558",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.44,212.7h26.45s.9-2.7-2.4-4.5-4.81-.3-6-1.81,3.3-5.41-5.71-9.31c0,0-.6-8.41-12.92-8.71-5.31-.13-7.72,1.42-9,3.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.37,
    y1: 212.7,
    x2: 431.77,
    y2: 212.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.24,195.91a4.9,4.9,0,0,1-1.71,3c-3.3,2.1-4.2-1.2-7.51.9s-1.8,6.31-4.51,6.91-6.3-2.7-9.61-.6-3.3,3.91-4.81,3.91-4.5-1.2-6.31,0-3.9,2.7-3.9,2.7h33.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--fuel-station--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.28,411h4.84V391.47a14.06,14.06,0,0,1,28.11,0V411h4.84V391.47a18.9,18.9,0,0,0-37.79,0Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.11,
    y: 172.1,
    width: 31.68,
    height: 230.31,
    transform: "translate(381.89 574.5) rotate(180)",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.11,
    y: 172.1,
    width: 13.86,
    height: 230.31,
    transform: "translate(364.07 574.5) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.11,
    y: 170.1,
    width: 31.68,
    height: 18.23,
    transform: "translate(381.89 358.43) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.11,
    y: 170.1,
    width: 13.86,
    height: 18.23,
    transform: "translate(364.07 358.43) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.86,
    y: 285.02,
    width: 6.29,
    height: 117.76,
    transform: "translate(344 687.8) rotate(180)",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.95,
    y: 285.02,
    width: 14.89,
    height: 117.76,
    transform: "translate(328.78 687.8) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.49,
    y: 322.51,
    width: 37.04,
    height: 80.27,
    transform: "translate(304.03 725.29) rotate(180)",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.49,
    y: 322.51,
    width: 37.04,
    height: 49.29,
    transform: "translate(304.03 694.31) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.49,
    y: 322.51,
    width: 37.04,
    height: 17.37,
    transform: "translate(304.03 662.38) rotate(180)",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.49,
    y: 339.72,
    width: 37.04,
    height: 7.89,
    transform: "translate(304.03 687.32) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.2,
    y: 285.02,
    width: 6.29,
    height: 117.76,
    transform: "translate(262.69 687.8) rotate(180)",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.29,
    y: 285.02,
    width: 14.89,
    height: 117.76,
    transform: "translate(247.47 687.8) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.55,
    y: 279.66,
    width: 69.21,
    height: 7.18,
    transform: "translate(290.31 566.51) rotate(180)",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.55,
    y: 279.66,
    width: 17.05,
    height: 7.18,
    transform: "translate(238.15 566.51) rotate(180)",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.55,
    y: 400.68,
    width: 69.21,
    height: 2.1,
    transform: "translate(290.31 803.47) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.55,
    y: 400.68,
    width: 17.05,
    height: 2.1,
    transform: "translate(238.15 803.47) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.84,
    y: 324.91,
    width: 15.96,
    height: 10.48,
    transform: "translate(305.64 660.29) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.26,
    y: 327.15,
    width: 9.12,
    height: 5.99,
    transform: "translate(305.64 660.29) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.84,
    y: 324.91,
    width: 15.96,
    height: 1.25,
    transform: "translate(305.64 651.07) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.31,
    y: 341.12,
    width: 9.98,
    height: 4.24,
    transform: "translate(322.61 686.48) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.31,
    y: 341.12,
    width: 9.98,
    height: 2,
    transform: "translate(322.61 684.24) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.61,
    y: 341.12,
    width: 9.98,
    height: 4.24,
    transform: "translate(287.19 686.48) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.61,
    y: 341.12,
    width: 9.98,
    height: 2,
    transform: "translate(287.19 684.24) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.91,
    y: 328.61,
    width: 7.69,
    height: 28.02,
    transform: "translate(247.51 685.24) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.91,
    y: 328.61,
    width: 5.72,
    height: 28.02,
    transform: "translate(245.55 685.24) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.13,
    y: 329.87,
    width: 3.29,
    height: 25.49,
    transform: "translate(245.55 685.24) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.77,
    y: 344.46,
    width: 2.12,
    height: 3.26,
    transform: "translate(259.66 692.18) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.63,
    y: 402.57,
    width: 186.66,
    height: 8.42,
    transform: "translate(387.92 813.55) rotate(180)",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.63,
    y: 402.57,
    width: 23.01,
    height: 8.42,
    transform: "translate(224.26 813.55) rotate(180)",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.08,411h4.84V391.47a14,14,0,1,1,28.1,0V411h4.84V391.47a18.89,18.89,0,1,0-37.78,0Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.9,
    y: 172.1,
    width: 31.68,
    height: 230.31,
    transform: "translate(965.47 574.5) rotate(180)",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.9,
    y: 172.1,
    width: 13.86,
    height: 230.31,
    transform: "translate(947.65 574.5) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.9,
    y: 172.1,
    width: 31.68,
    height: 18.23,
    transform: "translate(965.47 362.42) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.9,
    y: 172.1,
    width: 13.86,
    height: 18.23,
    transform: "translate(947.65 362.42) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.65,
    y: 285.02,
    width: 6.29,
    height: 117.76,
    transform: "translate(927.58 687.8) rotate(180)",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.74,
    y: 285.02,
    width: 14.89,
    height: 117.76,
    transform: "translate(912.36 687.8) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.28,
    y: 322.51,
    width: 37.04,
    height: 80.27,
    transform: "translate(887.61 725.29) rotate(180)",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.28,
    y: 322.51,
    width: 37.04,
    height: 49.29,
    transform: "translate(887.61 694.31) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.28,
    y: 322.51,
    width: 37.04,
    height: 17.37,
    transform: "translate(887.61 662.38) rotate(180)",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.28,
    y: 339.72,
    width: 37.04,
    height: 7.89,
    transform: "translate(887.61 687.32) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.99,
    y: 285.02,
    width: 6.29,
    height: 117.76,
    transform: "translate(846.27 687.8) rotate(180)",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.08,
    y: 285.02,
    width: 14.89,
    height: 117.76,
    transform: "translate(831.05 687.8) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.34,
    y: 279.66,
    width: 69.21,
    height: 7.18,
    transform: "translate(873.89 566.51) rotate(180)",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.34,
    y: 279.66,
    width: 17.05,
    height: 7.18,
    transform: "translate(821.73 566.51) rotate(180)",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.34,
    y: 400.68,
    width: 69.21,
    height: 2.1,
    transform: "translate(873.89 803.47) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.34,
    y: 400.68,
    width: 17.05,
    height: 2.1,
    transform: "translate(821.73 803.47) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.63,
    y: 324.91,
    width: 15.96,
    height: 10.48,
    transform: "translate(889.23 660.29) rotate(180)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.05,
    y: 327.15,
    width: 9.12,
    height: 5.99,
    transform: "translate(889.23 660.29) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.63,
    y: 324.91,
    width: 15.96,
    height: 1.25,
    transform: "translate(889.23 651.07) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.11,
    y: 341.12,
    width: 9.98,
    height: 4.24,
    transform: "translate(906.19 686.48) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.11,
    y: 341.12,
    width: 9.98,
    height: 2,
    transform: "translate(906.19 684.24) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.4,
    y: 341.12,
    width: 9.98,
    height: 4.24,
    transform: "translate(870.77 686.48) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.4,
    y: 341.12,
    width: 9.98,
    height: 2,
    transform: "translate(870.77 684.24) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.7,
    y: 328.61,
    width: 7.69,
    height: 28.02,
    transform: "translate(831.09 685.24) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.7,
    y: 328.61,
    width: 5.72,
    height: 28.02,
    transform: "translate(829.13 685.24) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.92,
    y: 329.87,
    width: 3.29,
    height: 25.49,
    transform: "translate(829.13 685.24) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.92,329.92c-3.54,2.27-5.55,8.18-5.64,8.45l1.26.42c0-.06,1.66-4.89,4.38-7.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.67,333.27h0a.22.22,0,0,0,.21-.24l-.12-2.11a.22.22,0,0,0-.23-.21.22.22,0,0,0-.21.23l.12,2.12A.21.21,0,0,0,414.67,333.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.14,335.15a.22.22,0,0,0,.22-.22v-2.12a.22.22,0,0,0-.22-.22.22.22,0,0,0-.22.22v2.12A.22.22,0,0,0,413.14,335.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.08,337.5h0a.23.23,0,0,0,.18-.26l-.48-2.24a.21.21,0,0,0-.26-.17.22.22,0,0,0-.17.26l.47,2.24A.23.23,0,0,0,412.08,337.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.49,344.58s-.59,5.65-.47,6.12,2.71,1.06,2.71,1.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408.28,354.35l4.23-1a2.3,2.3,0,0,0,1.72-2.44l-.63-6.07-1.33.14.64,6.07a1,1,0,0,1-.71,1l-4.23,1Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 408.31,
    y: 353.59,
    width: 1.77,
    height: 3.4,
    transform: "translate(-37.62 48.65) rotate(-6.51)",
    style: {
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.6,
    y: 344.54,
    width: 1.77,
    height: 9.09,
    transform: "translate(-36.92 48.54) rotate(-6.51)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.04 337.38 412.66 338.58 412.33 339.99 414.29 341.3 413.75 344.89 407.1 346.64 405.58 344.89 406.77 339.01 409.28 338.58 410.04 337.38",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.08 339.88 410.91 339.34 411.55 338.07 410.04 337.38 409.28 338.58 406.77 339.01 405.58 344.89 406.78 346.27 408.08 339.88",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.05,302.43c1.25-10.93,5.25-13.25,8.43-13.25h.1a7.13,7.13,0,0,1,5.3,2.42c5.4,5.82,4.65,20.41,4.6,21.36v33.27a.94.94,0,1,1-1.87,0V312.88c0-.15.83-14.7-4.1-20a5.28,5.28,0,0,0-4-1.82h-.06c-4.34,0-6,6.29-6.59,11.59a48.09,48.09,0,0,0,.86,15.71l1.42,6.53v8.8l-3.25-14.93A49.6,49.6,0,0,1,404.05,302.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.56,
    y: 344.46,
    width: 2.12,
    height: 3.26,
    transform: "translate(843.24 692.18) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M404.69,383.88c2-3.88,4.35-8.28,4.35-13.52,0-8-.65-14.5-.65-14.57l1.86-.18c0,.06.66,6.65.66,14.75,0,5.71-2.54,10.52-4.57,14.39-1.6,3.05-3,5.69-2.43,7.5a3,3,0,0,0,1.59,2.08,3.79,3.79,0,0,0,2.73-.24v2a6.28,6.28,0,0,1-1.8.29,4.29,4.29,0,0,1-1.62-.3,4.75,4.75,0,0,1-2.68-3.26C401.33,390.26,402.89,387.3,404.69,383.88Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 348.86,
    y: 402.57,
    width: 186.66,
    height: 8.42,
    transform: "translate(884.39 813.55) rotate(180)",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.86,
    y: 402.57,
    width: 23.01,
    height: 8.42,
    transform: "translate(720.74 813.55) rotate(180)",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.85,
    y: 141.07,
    width: 364.98,
    height: 38.27,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.92,
    y: 141.07,
    width: 300.11,
    height: 38.27,
    transform: "translate(441.96 320.41) rotate(180)",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,179.34V142.73L286.13,164a59.63,59.63,0,0,1-36-2.21l-18.56-7.15a46.48,46.48,0,0,0-26.83-2l-120,26.67Z",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.72,402.81s-2.07,4.33-1.7,5.23,2.78.86,2.78.86l.1-5.9S217.36,401.43,216.72,402.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.39,406s2.61,1.61,3.35,2,3.86,1.05,3.92,1.71-3,1.09-4.57,1.31a41.22,41.22,0,0,1-8.66-1.18c-.31-.24.85-4.2.85-4.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.62,349.32s-1.36,23.29-1.26,26.35-1,5.18-1.09,6.05-7.39,18.91-7.39,18.91l-1.39,4.16-2.85-4.36,3-20.43-3-30.16,7.61-1Z",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.74,350s1.68,10.07,3.44,14.35,4,15.81,4,15.81-1.4,5.8-.48,8.16,1,15.26,1,15.26a15.45,15.45,0,0,0-.16,2.28c.07.45.13,1.21.13,1.21s2.21-.38,3-.44,3.42-.51,3.42-.51.12-1.63.3-2.6-.47-2.55-.45-2.88,1.09-8.88,1.09-8.88,1.6-11.58,1.76-13.75-2.32-25.31-2.32-25.31-6.88-4.54-9.48-4.84S208.74,350,208.74,350Z",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.57,308.58s-9.59,5.38-9.63,5.9,1.91,21.34,1.91,21.34-1.2,11.87-1.29,13.16a19.19,19.19,0,0,0,.06,2.78l5.48-2.55s9.67,4.26,11,4.53l2.57.53,1.3-2.34.13,3a20.62,20.62,0,0,0,3.07-2.81l2.1-2.71-.94-13.26s-1-17.37-.89-18.32-1.15-6.08-2-6.76a33.87,33.87,0,0,0-4.73-2L218,307.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.15,298.23a10.58,10.58,0,0,0,1,2.71c.55.76,2.08,3,2.08,3l3.4-2L221,296Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.71 301.2 217.14 307.3 223.97 311.81 225.17 307.21 219.44 300.11 217.71 301.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.76 306.12 224.24 309.55 224.9 307.74 221.76 306.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.8,294.87l-.19,3.8-.5.92.09,3.57-.65.56s-1,3-1.19,3.3a7.71,7.71,0,0,1-1.57,1.19c-.35.14-3.85-1.85-4.4-2.67s-1.17-1.82-1.17-1.82l.11-2.68-.25-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.83,299.86v1a1.44,1.44,0,0,1-1.47-.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.29,305.05s-.33.07-1.06-.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.62 296.99 229.57 297.27 229.8 294.87 224.14 296.42 224.62 296.99",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.65,
    y1: 299.4,
    x2: 224.89,
    y2: 299.11,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.55,
    y1: 303.72,
    x2: 226.72,
    y2: 303.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4,294.69s-.53-3.59-1.75-4.72-7.59-2.05-8.22-1.75-1.76.87-1.76.87a13.94,13.94,0,0,0-2.19,1.51,4.1,4.1,0,0,0-1.7,3.18,25.07,25.07,0,0,0,.37,4.45Z",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.72 305.29 222.43 307.88 224.19 312.43 215.62 308.42 216.72 305.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.64,300.17s-.65-2.52-2-1.65.22,3.62.44,4,1,.44,1.43-.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.18,296.55s3.25,1.58,5.59,1.43c2.64-.18,8.14-.82,6.8-1.87a36.49,36.49,0,0,0-4.77-1.24S224.15,295.67,222.18,296.55Z",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.7,344.7c-3.1-2.85-9.33-3.27-9.61-3.29l-.08,1.33c.06,0,5.15.34,8.1,2.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.15,344.34h0a.22.22,0,0,0,.28.14l2-.65a.23.23,0,0,0,.14-.28.23.23,0,0,0-.28-.15l-2,.66A.23.23,0,0,0,255.15,344.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.93,343.34a.23.23,0,0,0,.27.16l2.05-.54a.23.23,0,0,0,.16-.27.22.22,0,0,0-.27-.16l-2,.54A.23.23,0,0,0,252.93,343.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.39,342.92s0,0,0,.05a.22.22,0,0,0,.3.09l2-1a.22.22,0,1,0-.2-.4l-2,1A.22.22,0,0,0,250.39,342.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.4,344.17s-5.61.88-6,1.12-.33,2.88-.33,2.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.13,343.57l2.07,3.83a2.28,2.28,0,0,0,2.8,1l5.7-2.17-.47-1.24-5.7,2.16a.94.94,0,0,1-1.16-.42l-2.07-3.83Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 230.75,
    y: 343.82,
    width: 3.4,
    height: 1.77,
    transform: "translate(-109.64 108.43) rotate(-21.37)",
    style: {
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.73,
    y: 341.54,
    width: 9.09,
    height: 1.77,
    transform: "translate(-108.41 110.39) rotate(-21.37)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.99 340.92 249.5 343.76 248.05 343.81 247.29 346.04 243.67 346.43 240.28 340.46 241.58 338.54 247.57 338.18 248.63 340.49 249.99 340.92",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.06 339.67 248.31 342.27 249.71 342.56 249.99 340.92 248.63 340.49 247.57 338.18 241.58 338.54 240.55 340.06 247.06 339.67",
    style: {
      fill: "#4EA32A",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.56 331.93 215.61 335 234.05 343.4 237.12 346.27 240.19 345.24 242.86 344.83 239.58 339.3 233.03 339.1 220.74 331.11 218.89 328.85 213.56 331.93",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "206.94 314.48 211.31 334.59 220.94 329.47 214.59 315.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55,344.5a43.73,43.73,0,0,0-21.22,12.27c-8.23,9-16.62,17.83-25.33,26.36-9.94,9.73-17.89,16.24-30.79,21.91-9.18,4-22.76,8-32.52,4-12.32-5.12-9.11-22.57-9.37-33.1-.52-20.94-.51-41.94.13-62.87.08-2.58.17-5.16.32-7.73.22-3.88.52-11.48,2.14-15,1.26-2.74,4-4.17,5.72-4.1,5.86.24,7.59,7.07,8.22,13.11s1.71,42.8,1.71,42.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.22,342.15h-.43a2.75,2.75,0,0,1-2.61-3.61c.55-1.69,1.48-3.4,3-3.66,3.24-.54,12.14,2.15,12.14,4s0,2.69-1.08,2.69h-6.74l-5.39,5.94-.12-.1a2.49,2.49,0,0,1,0-3.81A5.31,5.31,0,0,0,202.22,342.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.15,392.3h89.5s12.94-8.63,10.24-31.28-17.25-7.54-22.64,7.55h-39.9s-8.63-17.25-22.64-15.09S263.15,392.3,263.15,392.3Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.14,387.81a29.13,29.13,0,0,0-4.95-16.87v-6.3H269.4c-8.7,0-15.75,10.37-15.75,23.17S260.7,411,269.4,411h10.79v-6.3A29.13,29.13,0,0,0,285.14,387.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.19,
    cy: 387.81,
    rx: 15.74,
    ry: 23.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-62)"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.19,
    cy: 387.81,
    rx: 15.74,
    ry: 23.17,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.19,
    cy: 387.81,
    rx: 15.74,
    ry: 23.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.88,364.64H177.69c-8.22,0-14.88,10.37-14.88,23.17S169.47,411,177.69,411h10.19c8.22,0,14.88-10.37,14.88-23.17S196.1,364.64,187.88,364.64Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.19,
    cy: 387.81,
    rx: 12.56,
    ry: 18.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.87,387.81a42,42,0,0,0-3.15-16.87v-6.3h-9.53c-5.54,0-10,10.37-10,23.17s4.48,23.17,10,23.17h9.53v-6.3A42,42,0,0,0,358.87,387.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.72,
    cy: 387.81,
    rx: 10.02,
    ry: 23.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-62)"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.72,
    cy: 387.81,
    rx: 10.02,
    ry: 23.17,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.72,
    cy: 387.81,
    rx: 10.02,
    ry: 23.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.71,387.81c0,10.21-3.58,18.49-8,18.49s-8-8.28-8-18.49,3.58-18.49,8-18.49S363.71,377.6,363.71,387.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.92,393.47c0-18.46,6.42-33.43,14.33-33.43s14.33,15,14.33,33.43c0,1,0,2-.06,3h51.05c0-1-.05-2-.05-3C346.52,375,351.2,360,357,360c3.85,0,7.21,6.69,9,16.63V349.4a5.31,5.31,0,0,0-4.35-5.23l-.25-.05c-3.53-.71-9.9-7.43-19.81-15.92s-18.75-9.2-18.75-9.2H233.44a7.66,7.66,0,0,0-4.67,1.59l-30.48,23.53S171,349.42,165,355.44s-5.31,41-5.31,41H267C266.94,395.49,266.92,394.49,266.92,393.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.89,319H233.44a7.66,7.66,0,0,0-4.67,1.59l-30.48,23.53h86.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,353.58c-4.86.06-13.35.38-17,1.86a68.31,68.31,0,0,0-8.84,4.24H257Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.08,365v-3.18h-18.4l3.33,3.07a1,1,0,0,0-.15.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.85,360.39V365a4.67,4.67,0,0,0,3.53-2.15c1.77-2.83,5.75-9.29,5.75-9.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.74,364.88l3.33-3.07h-7.85c-.24,1-.47,2.06-.67,3.18h5.34A1,1,0,0,0,166.74,364.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.11,356.66a15.38,15.38,0,0,0-1.29,3h7.25A63.43,63.43,0,0,0,164.11,356.66Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.61,344.12H337s7.43-2.48,5.31-11.68c-.72-3.12-15.57-10.26-17.69-10.26H299.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-62)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.61,344.12H337s7.43-2.48,5.31-11.68c-.72-3.12-15.57-10.26-17.69-10.26H299.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M284.61,344.12H337s7.43-2.48,5.31-11.68c-.72-3.12-15.57-10.26-17.69-10.26H299.12Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.71 322.18 198.28 344.12 284.61 344.12 298.82 322.18 226.71 322.18",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.4 360.39 171.4 367.82 176.7 371.71 219.51 371.71 229.42 367.47 229.42 360.39 171.4 360.39",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.4,
    y: 360.39,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.58,
    y: 362.58,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.77,
    y: 364.77,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.96,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.05,
    y: 360.39,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.86,
    y: 362.58,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.67,
    y: 364.77,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.49,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.03,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.07,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.11,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.15,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.18,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.22,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.26,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.3,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.34,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.37,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.41,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.45,
    y: 366.95,
    width: 1.98,
    height: 1.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.94,380.91h-88.1l-1.18-9.44c-.54,5.19-.78,10.72-.89,15.26l.31,1.26,1.76-3.54h7.56l-4.72,3.89h70l-2.51-3.89h17.72l4.95,2.83h3.54v-18Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.13,344.12h2.95c-.31-4.34-1.55-13.9-6.41-21.94h-3C314.42,325.88,318.46,335.41,319.13,344.12Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.33,328.14l1.08,3a7,7,0,0,0-2.16,4.85v8.17h-6.63l5.55-16Zm-31,4c-4.55,2.77-11.43,8.88-14.76,11.94h22.16l11.47-17.6-7.55.54A47.66,47.66,0,0,0,224.33,332.18ZM270.16,330l-2.7-.54h-3.77l-1.08,1.08s2.7.27,3,1.89a41.06,41.06,0,0,1,.27,4.85h1.89s0-3,1.35-4.31a25.38,25.38,0,0,1,2.43-2.16Z",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.05,342.15h-.44a2.75,2.75,0,0,1-2.61-3.61c.55-1.69,1.48-3.4,3.05-3.66,3.23-.54,12.13,2.15,12.13,4s0,2.69-1.08,2.69h-6.74L302,347.55l-.12-.1a2.49,2.49,0,0,1,0-3.81A5.68,5.68,0,0,0,303.05,342.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.85,347.45l.12.1,5.39-5.94h6.74c.89,0,1-.56,1.07-1.82H299.9a2.73,2.73,0,0,0,2.71,2.36h.44a5.68,5.68,0,0,1-1.2,1.49A2.49,2.49,0,0,0,301.85,347.45Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.43,
    y: 350.63,
    width: 6.07,
    height: 1.3,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.73,
    y: 350.63,
    width: 6.07,
    height: 1.3,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.23,345.43s4.39,3,6.94,13.44c0,0-10.84,1.3-10.84,31.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,391.37H295.55q0,1,0,2.1c0,1,0,2-.06,3h51.05c0-1-.05-2-.05-3,0-.07,0-.14,0-.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.92,393.47q0-1.05,0-2.1H159.7c0,3.12,0,5.11,0,5.11H267C266.94,395.49,266.92,394.49,266.92,393.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.08,348a3.11,3.11,0,0,0-2.73,4.6l4.63,8.49V349.4a5.21,5.21,0,0,0-.2-1.37h-1.7Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.46,348.62s9.7,14,0,37.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.66,
    y: 148.63,
    width: 75.85,
    height: 262.35,
    style: {
      fill: "#666",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.09,
    y: 148.63,
    width: 75.85,
    height: 262.35,
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.09,
    y: 148.63,
    width: 75.85,
    height: 190.12,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.09,
    y: 221.33,
    width: 75.85,
    height: 44.61,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.44,
    y: 274.59,
    width: 57.06,
    height: 9.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.44,
    y: 296.51,
    width: 57.06,
    height: 9.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.44,
    y: 231.79,
    width: 57.06,
    height: 9.05,
    style: {
      fill: "#8f8f8f",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.44,
    y: 247.8,
    width: 57.06,
    height: 9.05,
    style: {
      fill: "#8f8f8f",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M666.61,365.8c1.55.68,5.36.59,5.37.59s-.82-2.49-.89-2.64c-.84-1.75-3.48-4.64-5.63-4.34a2.56,2.56,0,0,0-2.06,3.21C663.75,364.11,665.28,365.22,666.61,365.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.92,376.83c1.62.24,5-.75,5.29-.83a44,44,0,0,0,2.06,5.71c.47,1.08,1,2.16,1.49,3.23l-.63-.91c-1.27-1.47-4.58-3.55-6.58-2.7a2.57,2.57,0,0,0-1.14,3.65c.74,1.34,2.5,2,3.94,2.21a16.91,16.91,0,0,0,5.13-.79c.21.41.41.82.61,1.23,1,2,2,3.91,2.89,5.86.32.68.61,1.37.91,2.05-.28-.4-.51-.74-.55-.78-1.27-1.47-4.58-3.56-6.58-2.71a2.57,2.57,0,0,0-1.14,3.65c.74,1.34,2.51,2,3.94,2.22a16.59,16.59,0,0,0,5-.75c.28.71.56,1.42.8,2.12.15.49.33.94.46,1.43s.27,1,.4,1.45c.23.92.46,1.88.66,2.79.14.63.26,1.24.38,1.85-.31-.69-1-2-1-2.12-1-1.64-4-4.21-6.09-3.67a2.57,2.57,0,0,0-1.68,3.43c.53,1.44,2.17,2.36,3.56,2.79s4.9,0,5.32,0c.2,1,.39,2,.55,2.92.05.29.1.56.14.84h1.33c-.07-.35-.13-.7-.21-1.07-.2-1-.43-2.12-.69-3.24a26.77,26.77,0,0,0,3-1.39,18.89,18.89,0,0,0,4.33,2.79c-.39.95-.78,1.87-1.15,2.74a1.3,1.3,0,0,0-.08.17h1.39c.36-.87.72-1.79,1.08-2.75.41.09,3.75.76,5.31.41,1.41-.32,3.12-1.11,3.75-2.51a2.57,2.57,0,0,0-1.42-3.55c-2.06-.69-5.2,1.65-6.35,3.2-.06.1-.69,1.18-1.07,1.87.16-.44.33-.87.49-1.32.33-.9.63-1.8,1-2.77.14-.47.28-.95.43-1.44s.25-1,.38-1.5c.28-1.17.51-2.38.71-3.6a16.73,16.73,0,0,0,5,1.16c1.45-.1,3.26-.63,4.09-1.91a2.57,2.57,0,0,0-.86-3.73c-1.93-1-5.38.84-6.76,2.21-.08.08-1,1.18-1.43,1.78.12-.73.23-1.46.33-2.2.26-2.16.47-4.34.68-6.52l.21-2c.28.1,3.58,1.33,5.2,1.22,1.45-.1,3.26-.63,4.09-1.92a2.56,2.56,0,0,0-.86-3.72c-1.93-1-5.38.84-6.76,2.21-.1.1-1.36,1.67-1.66,2.09.16-1.47.32-2.93.55-4.36a43.07,43.07,0,0,1,1.25-5.73c.13,0,3.57,1.35,5.23,1.23,1.45-.1,3.26-.63,4.09-1.92a2.56,2.56,0,0,0-.86-3.72c-1.93-1-5.39.84-6.76,2.21-.11.1-1.46,1.8-1.68,2.12,0-.11,0-.22.08-.33a32.9,32.9,0,0,1,2.28-5.43c.49-1,1-1.86,1.55-2.72.61.31,3.44,1.69,4.95,1.75s3.31-.28,4.28-1.46a2.58,2.58,0,0,0-.45-3.8c-1.81-1.2-5.45.25-7,1.46-.08.06-.85.82-1.4,1.38l.74-1.15c.91-1.36,1.82-2.56,2.64-3.61.47-.6.91-1.13,1.32-1.62.77,0,3.84-.1,5.18-.73s2.81-1.77,3.13-3.26a2.58,2.58,0,0,0-2.15-3.17c-2.16-.23-4.72,2.73-5.51,4.5-.07.15-.86,2.67-.82,2.67h.05c-.41.46-.85,1-1.31,1.52-.84,1-1.79,2.22-2.73,3.57a46.31,46.31,0,0,0-2.83,4.51A33.76,33.76,0,0,0,701,375a.19.19,0,0,0,0,.07c0-.64,0-2.42,0-2.55-.25-1.92-1.86-5.49-4-5.89a2.57,2.57,0,0,0-3,2.42c-.13,1.53,1,3.05,2.06,4s4.59,2.14,4.86,2.22a46.18,46.18,0,0,0-1.42,5.9c-.21,1.16-.38,2.33-.54,3.52,0-.55,0-1.05,0-1.11-.25-1.93-1.86-5.49-4-5.89a2.58,2.58,0,0,0-3,2.42c-.12,1.52,1,3.05,2.06,4a16.93,16.93,0,0,0,4.72,2.17c-.05.46-.11.91-.17,1.36-.26,2.18-.51,4.36-.82,6.48-.11.75-.24,1.49-.38,2.22,0-.49,0-.9,0-1-.25-1.92-1.86-5.49-4-5.89a2.57,2.57,0,0,0-3,2.42c-.12,1.53,1,3.05,2.06,4a16.4,16.4,0,0,0,4.59,2.13c-.16.75-.32,1.5-.51,2.22-.13.48-.23,1-.4,1.44s-.31,1-.46,1.43c-.33.9-.66,1.82-1,2.69-.23.6-.46,1.18-.69,1.75.11-.74.31-2.2.31-2.33a9.94,9.94,0,0,0-1.33-4.85,3.64,3.64,0,0,0,0-.57,2.57,2.57,0,0,0-3.14-2.18c-2.1.56-3.43,4.24-3.53,6.18,0,.11.07,1.36.13,2.14-.1-.45-.2-.9-.31-1.36-.22-.93-.47-1.85-.73-2.84-.15-.47-.29-.95-.44-1.44s-.33-1-.5-1.46c-.42-1.14-.89-2.27-1.4-3.39.81-.2,3.69-.93,4.84-1.82s2.37-2.32,2.36-3.85a2.57,2.57,0,0,0-2.78-2.63c-2.16.23-4,3.67-4.42,5.57,0,.12-.15,1.51-.21,2.28-.31-.68-.61-1.35-.94-2-1-2-2-3.88-3-5.82-.32-.59-.62-1.19-.93-1.78.29-.07,3.72-.86,5-1.85,1.14-.88,2.36-2.33,2.35-3.86a2.57,2.57,0,0,0-2.77-2.63c-2.16.24-4,3.67-4.43,5.57,0,.15-.21,2.15-.23,2.66-.68-1.31-1.34-2.62-1.94-3.93a44,44,0,0,1-2.12-5.47c.13,0,3.72-.85,5-1.87,1.15-.88,2.37-2.32,2.36-3.85a2.57,2.57,0,0,0-2.78-2.63c-2.15.24-4,3.67-4.42,5.57,0,.15-.22,2.31-.23,2.7,0-.11-.08-.22-.11-.33a33.41,33.41,0,0,1-1.1-5.77c-.12-1.08-.18-2.12-.21-3.13.69-.08,3.81-.5,5.1-1.28s2.61-2,2.76-3.57a2.56,2.56,0,0,0-2.46-2.92c-2.17,0-4.41,3.21-5,5,0,.1-.25,1.16-.4,1.93,0-.46,0-.93,0-1.36,0-1.65.11-3.15.21-4.48.06-.75.14-1.44.21-2.07.63-.44,3.14-2.21,3.91-3.47a5.37,5.37,0,0,0,.81-4.45,2.57,2.57,0,0,0-3.53-1.45c-1.93,1-2.44,4.88-2.12,6.79,0,.16.75,2.7.79,2.67l0,0c-.09.61-.17,1.27-.25,2-.13,1.33-.27,2.83-.31,4.48a46.19,46.19,0,0,0,.13,5.32,33.19,33.19,0,0,0,1,5.87.14.14,0,0,0,0,.07c-.34-.53-1.35-2-1.44-2.11-1.27-1.46-4.58-3.55-6.58-2.7a2.56,2.56,0,0,0-1.13,3.65C664.72,376,666.49,376.63,667.92,376.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.14,366.64s.69-2.53.71-2.7c.27-1.92-.34-5.78-2.29-6.73a2.57,2.57,0,0,0-3.5,1.55,5.36,5.36,0,0,0,.93,4.42C701.91,364.61,705.14,366.64,705.14,366.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.73,382.15a11.58,11.58,0,0,0,3.43.38s-.52-1.59-.57-1.69c-.53-1.11-2.22-2.95-3.59-2.77a1.65,1.65,0,0,0-1.32,2.06A3.44,3.44,0,0,0,619.73,382.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.57,389.19a11.4,11.4,0,0,0,3.37-.53,30,30,0,0,0,1.32,3.64c.3.69.62,1.38,1,2.07-.2-.29-.38-.55-.4-.59-.81-.93-2.93-2.26-4.2-1.72a1.64,1.64,0,0,0-.73,2.33,3.43,3.43,0,0,0,2.51,1.41,10.68,10.68,0,0,0,3.28-.5l.39.78c.63,1.25,1.26,2.5,1.84,3.74.21.44.4.87.58,1.31-.17-.26-.32-.47-.35-.5-.81-.94-2.92-2.27-4.2-1.73a1.65,1.65,0,0,0-.72,2.33,3.45,3.45,0,0,0,2.51,1.42,10.76,10.76,0,0,0,3.19-.48c.18.45.36.91.51,1.35s.22.6.3.92.17.61.25.92c.15.59.3,1.2.42,1.78.09.4.17.79.25,1.18-.2-.44-.61-1.29-.65-1.35-.66-1.05-2.55-2.69-3.89-2.35a1.65,1.65,0,0,0-1.07,2.2,3.41,3.41,0,0,0,2.27,1.77,11,11,0,0,0,3.39,0c.13.65.25,1.27.35,1.87,0,.18.06.36.09.53H633c0-.22-.08-.45-.13-.68-.13-.66-.28-1.35-.44-2.07a15.87,15.87,0,0,0,1.89-.89,11.9,11.9,0,0,0,2.76,1.78c-.24.61-.49,1.2-.73,1.75a1.17,1.17,0,0,1-.05.11h.89l.69-1.75a11.56,11.56,0,0,0,3.38.26,3.44,3.44,0,0,0,2.4-1.6,1.65,1.65,0,0,0-.91-2.27c-1.31-.44-3.31,1.05-4.05,2.05,0,.05-.44.74-.69,1.18l.32-.84c.21-.57.4-1.14.61-1.76l.27-.92c.1-.3.17-.64.25-1,.18-.75.32-1.52.45-2.29a10.72,10.72,0,0,0,3.21.73,3.4,3.4,0,0,0,2.61-1.22,1.62,1.62,0,0,0-.55-2.37c-1.23-.64-3.43.53-4.31,1.4-.06.06-.61.76-.91,1.14.07-.46.15-.93.2-1.41.18-1.37.3-2.76.44-4.16,0-.42.09-.85.13-1.27a11.43,11.43,0,0,0,3.32.78,3.49,3.49,0,0,0,2.62-1.22,1.64,1.64,0,0,0-.56-2.38c-1.23-.63-3.43.54-4.31,1.41-.06.06-.87,1.07-1.06,1.33.1-.93.21-1.86.35-2.78a30,30,0,0,1,.8-3.66,11.39,11.39,0,0,0,3.34.79,3.4,3.4,0,0,0,2.61-1.22,1.64,1.64,0,0,0-.55-2.38c-1.23-.63-3.44.54-4.32,1.41-.06.07-.93,1.15-1.07,1.35l.06-.21a20.76,20.76,0,0,1,1.45-3.46c.31-.61.65-1.19,1-1.74a11,11,0,0,0,3.17,1.12,3.48,3.48,0,0,0,2.73-.93,1.64,1.64,0,0,0-.29-2.42c-1.15-.77-3.48.15-4.44.92l-.89.89c.15-.25.31-.5.47-.74.58-.87,1.16-1.63,1.68-2.3.3-.38.58-.72.85-1A11.1,11.1,0,0,0,651,378a3.44,3.44,0,0,0,2-2.08,1.63,1.63,0,0,0-1.37-2c-1.37-.15-3,1.74-3.51,2.87,0,.09-.55,1.7-.53,1.7h0c-.26.29-.53.61-.83,1-.54.66-1.14,1.41-1.74,2.28a29,29,0,0,0-1.8,2.87,21.68,21.68,0,0,0-1.55,3.48.06.06,0,0,1,0,0c0-.4,0-1.54,0-1.63-.16-1.22-1.19-3.5-2.55-3.75a1.64,1.64,0,0,0-1.89,1.54,3.43,3.43,0,0,0,1.32,2.57,11.27,11.27,0,0,0,3.1,1.41,30.06,30.06,0,0,0-.91,3.77c-.13.74-.24,1.49-.34,2.24,0-.35,0-.66,0-.71-.16-1.22-1.19-3.5-2.55-3.75a1.64,1.64,0,0,0-1.89,1.54,3.47,3.47,0,0,0,1.31,2.57,10.78,10.78,0,0,0,3,1.38c0,.29-.08.58-.11.87-.17,1.39-.33,2.78-.53,4.14q-.11.71-.24,1.41c0-.31,0-.57,0-.61-.16-1.23-1.19-3.51-2.55-3.76a1.64,1.64,0,0,0-1.89,1.54,3.42,3.42,0,0,0,1.31,2.57,10.73,10.73,0,0,0,2.93,1.36c-.1.48-.2.95-.32,1.41s-.16.62-.26.93l-.3.91c-.2.57-.42,1.16-.63,1.71-.15.39-.3.75-.45,1.12.08-.47.21-1.41.21-1.49a6.36,6.36,0,0,0-.86-3.09,1.45,1.45,0,0,0,0-.36,1.63,1.63,0,0,0-2-1.39c-1.34.35-2.19,2.7-2.25,3.94,0,.07,0,.86.08,1.36-.07-.29-.13-.57-.2-.87-.14-.59-.3-1.18-.47-1.81l-.27-.91c-.09-.31-.22-.63-.33-.94-.26-.72-.57-1.44-.89-2.16a11.15,11.15,0,0,0,3.09-1.16,3.41,3.41,0,0,0,1.5-2.46,1.64,1.64,0,0,0-1.77-1.68c-1.37.15-2.57,2.35-2.82,3.56,0,.07-.1,1-.13,1.45-.2-.43-.39-.86-.61-1.29-.61-1.24-1.27-2.48-1.93-3.71l-.59-1.14a11.38,11.38,0,0,0,3.2-1.18,3.41,3.41,0,0,0,1.5-2.46,1.64,1.64,0,0,0-1.77-1.68c-1.37.15-2.57,2.35-2.82,3.56,0,.09-.13,1.37-.15,1.69-.43-.83-.85-1.67-1.24-2.51a28.81,28.81,0,0,1-1.35-3.49,11.57,11.57,0,0,0,3.22-1.19A3.41,3.41,0,0,0,629,385a1.64,1.64,0,0,0-1.77-1.67c-1.38.15-2.57,2.34-2.82,3.55,0,.1-.14,1.47-.15,1.72,0-.07,0-.13-.07-.2a21.14,21.14,0,0,1-.7-3.69c-.08-.69-.11-1.35-.13-2a11.24,11.24,0,0,0,3.25-.82,3.43,3.43,0,0,0,1.76-2.28,1.63,1.63,0,0,0-1.57-1.86c-1.39,0-2.81,2-3.2,3.22,0,.06-.16.74-.25,1.23,0-.29,0-.59,0-.87,0-1,.06-2,.13-2.86,0-.48.09-.91.14-1.32a11.19,11.19,0,0,0,2.49-2.21,3.44,3.44,0,0,0,.52-2.84,1.64,1.64,0,0,0-2.26-.93c-1.23.64-1.55,3.11-1.35,4.33,0,.11.48,1.73.5,1.71h0c-.06.39-.11.81-.16,1.27-.08.84-.17,1.8-.2,2.86a30.42,30.42,0,0,0,.09,3.39,21.4,21.4,0,0,0,.62,3.75l0,0c-.22-.34-.86-1.28-.92-1.34-.81-.94-2.92-2.27-4.19-1.73a1.64,1.64,0,0,0-.73,2.33A3.4,3.4,0,0,0,620.57,389.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.32,382.69s.44-1.62.46-1.72c.17-1.23-.22-3.7-1.47-4.3a1.64,1.64,0,0,0-2.23,1,3.4,3.4,0,0,0,.59,2.82A11.8,11.8,0,0,0,644.32,382.69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-62"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 21.65,
    y1: 410.98,
    x2: 722.32,
    y2: 410.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorqueLumien);
export default __webpack_public_path__ + "static/media/porque-lumien.e2c82cb8abc18cda4a6f73102ed3fd7c.svg";
export { ForwardRef as ReactComponent };